import {Component, OnInit } from "@angular/core";
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AlgebraKiTService } from "src/app/modules/algebrakit/services/algebrakit.service";
import { ExerciseResult } from "src/app/modules/algebrakit/types/algebrakit.types";
import {Location} from '@angular/common'; 
import { THEMES, ThemeSpec } from "../../types/akit-testbench-types"
declare let AlgebraKIT: any;

const DEFAULT_EXERCISE_ID = 'fa42e943-8213-41a6-8a91-8c22a929ffe9';

@Component({
    templateUrl: "./demo.container.html",
    styleUrls: ["./demo.container.less"],
    selector: "app-demo",
    standalone: false
})
export class DemoContainer implements OnInit {
    public inputForm: UntypedFormGroup;
    public exerciseId: string;
    public sessionId: string;
    public viewMode: string; //solution, review, scoring, session
    public exerciseResult: ExerciseResult;
    public theme: ThemeSpec = THEMES[0];
    public assessmentMode = false;
    public themes = THEMES;
    public showSolution = false;
    public showReview = false;

    refId: string;  //if set, show only this interaction instead of the exercise

    sessionData: any;
    exerciseData: any;

    get akitExerciseElement():Element {
        return document.querySelector(".input-section akit-exercise");
    }

    renderPromise: Promise<void>;
    renderResolve: () => void; //to resolve promise after render

    constructor(
        private formBuilder: UntypedFormBuilder,
        private akitService: AlgebraKiTService,
        private route: ActivatedRoute,
    ) {}

    async ngOnInit() {
        let reqAM = this.route.snapshot.queryParamMap.get("assessment");
        if(reqAM && reqAM.toLowerCase() == 'true') {
            this.assessmentMode = true;
        }

        this.setBehaviorOptions();

        let id = this.route.snapshot.paramMap.get("id");
        if(!id) {
            id = this.akitService.getCurrentExerciseId();

            // if the exercise has not interactions, fallback to the default exercise
            let spec = this.akitService.getExerciseFromCache();
            if(spec && this.akitService.isEmptyExercise(spec)) id = null;

            if(!id) id = DEFAULT_EXERCISE_ID;
        }
        if(id) this.akitService.setCurrentExerciseId(id);
        this.exerciseId = id;

        this.inputForm = this.formBuilder.group({
            inputData: this.formBuilder.group({
                assessment_cb: new UntypedFormControl(this.assessmentMode),
            }),
        });

        this.inputForm.get('inputData.assessment_cb').valueChanges.subscribe(_value => this.setAssessmentMode(_value));
    }

    setBehaviorOptions() {
        if(!AlgebraKIT.config.behavior || !AlgebraKIT.config.behavior.general) AlgebraKIT.config.behavior = {general: {}};
        AlgebraKIT.config.behavior.general.externalSubmitButton = this.assessmentMode;
        if(AlgebraKIT._api) {
            AlgebraKIT._api.config = AlgebraKIT._api.getProfile('akit')
        }
    }

    onSessionCreated(sessionId: string) {
        this.sessionId = sessionId;
    }
    
    lockSession() {
        return this.akitService.lockSession(this.sessionId);
    }

    getScore(lockSession:boolean) {
        return this.akitService.getSessionScore(this.sessionId, lockSession);
    }

    setAssessmentMode(value: boolean) {
        if(value!=this.assessmentMode){
            this.assessmentMode = value;
            this.setBehaviorOptions();
            this.refreshResults();
        }
    }

    async showSolutionFc(value: boolean) {

        this.exerciseResult = await this.getScore(this.assessmentMode).toPromise();
        if(value && this.assessmentMode) {
            await this.lockSession();
            this.akitExerciseElement.setAttribute('interactive-mode', 'false');
        }
        this.showSolution = value;
    }

    async showResult(value: boolean) {
        if(!this.akitExerciseElement) return;

        await (this.akitExerciseElement as any).submit();
        this.exerciseResult = await this.getScore(this.assessmentMode).toPromise();
        if(value && this.assessmentMode) {
            this.akitExerciseElement.setAttribute('interactive-mode', 'false');
        }
        this.showReview = value;

    }

    showInteraction(refId: string) {
        this.refId = refId;
    }

    refreshResults() {
        this.showReview = false;
        this.showSolution = false;
    }

    getExerciseStatus() {
        if(this.exerciseResult) {
            if(this.exerciseResult.scoring.finished) {
                return 'Correctly answered';
            } else if(this.exerciseResult.scoring.marksEarned > 0) {
                return 'Partially answered';
            } else {
                return 'Not answered correctly';
            }
        }
    }
    ngAfterViewChecked(): void {
        if (this.renderResolve) {
            this.renderPromise = null;
            this.renderResolve();
        }
    }

    waitForRender(): Promise<void> {
        if (!this.renderPromise) {
            this.renderPromise = new Promise((resolve, reject) => {
                this.renderResolve = resolve;
            });
        }
        return this.renderPromise;
    }

}
